export const toggleFooter = () => {
  const contactButton = document.querySelector('[data-ref="aui-footer.open-contact-dialog"]') as HTMLElement;
  if (contactButton != null) contactButton.click();
};
